import { Box, Button } from "@mui/material";
import { actionSetCreateDialog } from "../../../../../store/exam/reducer";
import { useAppDispatch } from "../../../../../store/hooks";
import { OpenURL } from "../../../../../tools/url";
import homeImage from "../asset/head.jpg";

export function Banner() {
    const dispatch = useAppDispatch();
    return (
        <Box
            sx={{
                m: "10px",
                width: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
            }}
        >
            <Box sx={{ position: "relative" }}>
                <Box>
                    <img src={homeImage} width="100%" alt="顶部图" />
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        // border: "solid 1px",
                        left: "10%",
                        top: "35%",
                        width: "23%",
                        height: "7%",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        OpenURL("https://mp.weixin.qq.com/s/cgNBx69KiJs_T7R823wYhQ");
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        // border: "solid 1px",
                        left: "43%",
                        top: "35%",
                        width: "23%",
                        height: "7%",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        OpenURL("https://mp.weixin.qq.com/s/HMEKiF2b93Nol4jh4acKzg");
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        // border: "solid 1px",
                        left: "10%",
                        bottom: "26%",
                        width: "23%",
                        height: "7%",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        OpenURL("https://mp.weixin.qq.com/s/cna9hMk6G2n7vp0HY0w5Ig");
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        // border: "solid 1px",
                        left: "43%",
                        bottom: "26%",
                        width: "25%",
                        height: "7%",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        OpenURL("https://mp.weixin.qq.com/s/k5U7An5BlHgfAQGXGeTF6w");
                    }}
                />
            </Box>

            <Button
                sx={{
                    position: "absolute",
                    top: "8%",
                    right: "2%",
                    fontSize: 18,
                }}
                variant="contained"
                onClick={() => {
                    dispatch(actionSetCreateDialog(true));
                }}
            >
                创建新模考
            </Button>
        </Box>
    );
}
